import React from "react"
import styled from "styled-components"
import { media } from "src/styles/breakpoints"

const defaultItems = [
  {
    title: "facebook",
    url: "https://www.facebook.com/AnimaInter",
  },
  {
    title: "instagram",
    url: "https://www.instagram.com/anima_int",
  },
  {
    title: "twitter",
    url: "https://x.com/anima_int",
  },
  {
    title: "bluesky",
    url: "https://bsky.app/profile/anima-int.bsky.social",
  },
  {
    title: "linkedin",
    url: "https://www.linkedin.com/company/4549986",
  },
  {
    title: "youtube",
    url: "https://www.youtube.com/@animainternational130",
  },
]

const iconPaths = {
  facebook:
    "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z",
  instagram:
    "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12s.014 3.668.072 4.948c.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24s3.668-.014 4.948-.072c4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948s-.014-3.667-.072-4.947C23.732 2.699 21.311.273 16.949.073 15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z",
  twitter:
    "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z",
  bluesky:
    "M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364-3.912.58-7.387 2.005-2.83 7.078 5.013 5.19 6.87-1.113 7.823-4.308.953 3.195 2.05 9.271 7.733 4.308 4.267-4.308 1.172-6.498-2.74-7.078 2.67.296 5.568-.628 6.383-3.364.246-.829.624-5.79.624-6.479 0-.688-.139-1.86-.902-2.203-.659-.299-1.664-.621-4.3 1.24C16.046 4.747 13.087 8.686 12 10.8z",
  linkedin:
    "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z",
  youtube:
    "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z",
}

const SocialMediaIcons = ({ media: mediaProp, className }) => {
  const items = mediaProp || defaultItems
  return (
    <List className={className}>
      {items.map(({ title, url }, index) => (
        <Item key={index}>
          <ItemLink
            target="_blank"
            rel="noopener noreferrer"
            href={url}
            aria-label={title}
          >
            <SVG viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d={iconPaths[title]} />
            </SVG>
          </ItemLink>
        </Item>
      ))}
    </List>
  )
}

const List = styled.ul`
  display: flex;
`

const Item = styled.li`
  margin-right: 6px;
  margin-bottom: 6px;

  ${media.desktop} {
    margin-right: 12px;
  }
`

const ItemLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 38px;
  height: 38px;
  position: relative;
  border-radius: 50%;

  &::before,
  &::after {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 50%;
    pointer-events: none;
    transition: 0.15s;
  }

  &::before {
    border: 1px solid #cfdbdb;
  }

  &::after {
    opacity: 0;
    background-image: linear-gradient(-20deg, #3ab6da, #50d9d6);
  }

  &:hover {
    &::after {
      opacity: 1;
    }
  }
`

const SVG = styled.svg`
  width: 13px;
  height: 13px;
  fill: #98a5a5;
  position: relative;
  z-index: 1;
  transition: 0.15s;

  ${ItemLink}:hover & {
    fill: #fff;
  }
`

export default SocialMediaIcons